import { Globe, Check, Wand2 } from 'lucide-react';

interface Props {
  candidates: string[];
  selected: string | null;
  onSelect: (site: string) => void;
  loading: boolean;
  foundCount: number;
  socialLinks: string[];
}

/** Mostra i siti trovati nella firma e lo stato dell'analisi. */
export function ProspectIntelPanel({ candidates, selected, onSelect, loading, foundCount, socialLinks }: Props) {
  if (candidates.length === 0 && socialLinks.length === 0) return null;

  return (
    <div className="rounded-xl border border-[rgba(55,53,47,0.09)] dark:border-gray-700 bg-[rgba(55,53,47,0.025)] dark:bg-white/[0.04] p-3 space-y-2.5 mail-link-section">
      <div className="flex items-center gap-1.5">
        <Wand2 className={`h-3 w-3 text-[#2383E2] ${loading ? 'animate-pulse' : ''}`} />
        <p className="text-[11px] uppercase tracking-wide font-semibold text-[#787774] dark:text-white/50">
          Rilevato dalla firma
        </p>
      </div>

      {candidates.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {candidates.map((site, i) => (
            <button
              key={site}
              type="button"
              onClick={() => onSelect(site)}
              style={{ animationDelay: `${i * 30}ms` }}
              className={`mail-link-row inline-flex items-center gap-1.5 pl-2 pr-2.5 py-1 rounded-full text-xs transition-all duration-150 ${
                selected === site
                  ? 'bg-[#2383E2] text-white shadow-sm shadow-[#2383E2]/25'
                  : 'bg-white dark:bg-gray-800 text-[#37352F] dark:text-white border border-[rgba(55,53,47,0.09)] dark:border-gray-700 hover:border-[#2383E2] hover:text-[#2383E2]'
              }`}
            >
              {selected === site ? <Check className="h-3 w-3" /> : <Globe className="h-3 w-3" />}
              {site}
            </button>
          ))}
        </div>
      )}

      {candidates.length > 1 && !selected && !loading && (
        <p className="text-xs text-[#787774] dark:text-white/40">
          Scegli quale sito e` quello aziendale per compilare i campi.
        </p>
      )}

      {loading && (
        <div className="space-y-1.5" aria-live="polite">
          <p className="text-xs text-[#787774] dark:text-white/50">Analisi del sito in corso...</p>
          <div className="mail-link-skeleton h-1 rounded-full w-full" />
        </div>
      )}

      {!loading && foundCount > 0 && (
        <p className="flex items-center gap-1 text-xs text-[#0F7B6C] dark:text-emerald-400">
          <Check className="h-3 w-3 flex-shrink-0" />
          {foundCount} {foundCount === 1 ? 'campo compilato' : 'campi compilati'} in automatico
        </p>
      )}

      {candidates.length === 0 && socialLinks.length > 0 && (
        <p className="text-xs text-[#787774] dark:text-white/40">
          Nella firma ci sono solo profili social, nessun sito aziendale.
        </p>
      )}
    </div>
  );
}
